import React from 'react';
import AdminProfessionApproval from '../../components/admin/AdminProfessionApproval';

const Approvals: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">Content Approvals</h1>
          <p className="text-gray-600 mb-6">
            Review and approve user-submitted professions and categories across all business types.
          </p>
          
          {/* Profession Approvals Component */}
          <AdminProfessionApproval />
        </div>
      </div>
    </div>
  );
};

export default Approvals;
